import React from "react";
import Icon from "../Icon";

export const ExpanderCell = ({row}) => {
  if (row.canExpand) {
    const toggleRowExpandedProps = row.getToggleRowExpandedProps({
      style: {
        paddingLeft: `${row.depth * 2}rem`,
        width: "100%",
        textAlign: "right",
        fontSize: "1.5em"
      }})
    return <div
      {...toggleRowExpandedProps}
      onClick = {(e) => {
        e.stopPropagation();
        toggleRowExpandedProps.onClick(e)
      }}>
      {row.isExpanded ? <Icon icon="minusLight"/> : <Icon icon="plusLight"/>}
    </div>
  } else if (row.depth >= 1) {
    return <div style={{
      width: "100%",
      textAlign: "right"
    }}>
      <Icon icon="arrowListElement"/>
    </div>
  } else {
    return ''
  }
}
